export var SparkyDifficulty;
(function (SparkyDifficulty) {
    SparkyDifficulty["EASY"] = "easy";
    SparkyDifficulty["MEDIUM"] = "medium";
    SparkyDifficulty["HARD"] = "hard";
    SparkyDifficulty["LEGENDARY"] = "legendary";
})(SparkyDifficulty || (SparkyDifficulty = {}));
